module.exports = {
  initials: 'global/initials',
  logout: 'global/logout'
}
